<template>
  <v-container v-if="tournaments">
      <v-row
        no-gutters
      >
        <v-col>
        </v-col>

        <v-col>
          <v-text-field
    label="Buscar"
    v-model="search"
    v-debounce:1s="performSearch"
  >
<template v-slot:prepend-inner>

  <v-icon icon="mdi-magnify" />

</template>
  </v-text-field>
        </v-col>

        <v-col>
        </v-col>
      </v-row>
    </v-container>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Descripcion
        </th>
        <th class="text-center">
          Ciudad
        </th>
        <th class="text-center">
          Fecha
        </th>
        <th class="text-center">
          Estado
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in tournaments"
        :key="item.id"
      >
        <td class="text-left" style="width: 800px"><a :href="'/resultados_torneo/'+item.id" style="color:blue">{{ item.title }}</a></td>
        <td class="text-center">{{ item.city }}</td>
        <td class="text-center">{{ item.start_date }}</td>
        <td v-if="item.period_ranked_id" class="text-center">Rankeado</td>
        <td v-else class="text-center">En proceso de ranking</td>
      </tr>
    </tbody>
  </v-table>
</template>

<script>
  import gql from "graphql-tag";
  import { vue3Debounce } from 'vue-debounce'
  export default {
    directives: {
    debounce: vue3Debounce({ lock: true })
  },
    apollo: {
    tournaments: {query: gql`  query($word:String!){
       tournaments:rankedTournaments(word:$word){
        id
        title
        city
        start_date:startDateFormated
        period_ranked_id:periodRankedId
      }
    }`,
      variables() {return {"word" :this.search_net}}

    },
  },
    name:"TournamentRankedChess",
    data () {
      return {
        tournaments:null,
        search:"",
        search_net:"",
      }
    },
    methods: {
    performSearch(newVal,type ) {
      console.log('debounced', newVal, type)
      this.search_net = newVal;
    },
  },
  }
</script>

